import React from 'react';
const TrolleyIcon = () => {
  return (
    <svg
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2213_8719)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.6666 15.7417C9.19716 15.7417 8.8166 16.1222 8.8166 16.5917C8.8166 17.0611 9.19716 17.4416 9.6666 17.4416C10.136 17.4416 10.5166 17.0611 10.5166 16.5917C10.5166 16.1222 10.136 15.7417 9.6666 15.7417ZM8.0166 16.5917C8.0166 15.6804 8.75533 14.9417 9.6666 14.9417C10.5779 14.9417 11.3166 15.6804 11.3166 16.5917C11.3166 17.5029 10.5779 18.2416 9.6666 18.2416C8.75533 18.2416 8.0166 17.5029 8.0166 16.5917Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.4996 15.7417C15.0302 15.7417 14.6496 16.1222 14.6496 16.5917C14.6496 17.0611 15.0302 17.4416 15.4996 17.4416C15.9691 17.4416 16.3496 17.0611 16.3496 16.5917C16.3496 16.1222 15.9691 15.7417 15.4996 15.7417ZM13.8496 16.5917C13.8496 15.6804 14.5883 14.9417 15.4996 14.9417C16.4109 14.9417 17.1496 15.6804 17.1496 16.5917C17.1496 17.5029 16.4109 18.2416 15.4996 18.2416C14.5883 18.2416 13.8496 17.5029 13.8496 16.5917Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.18359 3.6749C2.18359 3.45399 2.36268 3.2749 2.58359 3.2749H5.21722C5.32354 3.27498 5.42711 3.30867 5.51313 3.37115C5.59915 3.43362 5.66322 3.5217 5.69618 3.62278L5.70045 3.63586L6.03444 4.96372L18.8169 6.65775V10.7582C18.8169 11.4169 18.5553 12.0485 18.0896 12.5142C17.6239 12.9799 16.9922 13.2416 16.3336 13.2416H7.69143C7.57903 13.2431 7.46927 13.207 7.37966 13.1388C7.28824 13.0694 7.22328 12.9708 7.19552 12.8594C7.19543 12.859 7.19534 12.8586 7.19524 12.8582L4.98596 4.0749H2.58359C2.36268 4.0749 2.18359 3.89582 2.18359 3.6749ZM6.24443 5.79855L7.91535 12.4416H16.3336C16.78 12.4416 17.2082 12.2642 17.5239 11.9485C17.8396 11.6328 18.0169 11.2047 18.0169 10.7582V7.35872L6.24443 5.79855Z"
          fill="white"
        />
        <path
          d="M7.58353 12.7624L5.84082 5.34155L18.4169 7.0082V10.7582C18.4169 11.3107 18.1974 11.8406 17.8067 12.2313C17.416 12.622 16.8861 12.8415 16.3335 12.8415H7.6877C7.6639 12.8422 7.64058 12.8348 7.62163 12.8203C7.60268 12.8059 7.58923 12.7855 7.58353 12.7624Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.31836 4.8689L18.8163 6.65772V10.7582C18.8163 11.4168 18.5546 12.0485 18.0889 12.5142C17.6232 12.9799 16.9916 13.2415 16.3329 13.2415H7.69074C7.57835 13.243 7.46861 13.2069 7.37902 13.1388C7.28728 13.0691 7.2222 12.9701 7.1946 12.8582L7.19406 12.856L5.31836 4.8689ZM6.36212 5.81422L7.91849 12.4415H16.3329C16.7794 12.4415 17.2076 12.2642 17.5232 11.9485C17.8389 11.6328 18.0163 11.2047 18.0163 10.7582V7.35869L6.36212 5.81422Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.49104 12.3733C7.70594 12.3221 7.92164 12.4548 7.97281 12.6697L8.28562 13.9836C8.2972 14.033 8.32514 14.077 8.36489 14.1085C8.40462 14.14 8.45382 14.1572 8.50452 14.1572C8.50455 14.1572 8.50448 14.1572 8.50452 14.1572H17.5045C17.7254 14.1572 17.9045 14.3363 17.9045 14.5572C17.9045 14.7781 17.7254 14.9572 17.5045 14.9572H8.50452C8.2734 14.9571 8.04899 14.879 7.86789 14.7354C7.68699 14.592 7.5598 14.3917 7.50693 14.167L7.19456 12.855C7.14339 12.6401 7.27613 12.4244 7.49104 12.3733Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_2213_8719">
          <rect
            width="20"
            height="20"
            fill="white"
            transform="translate(0.5 0.758301)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default TrolleyIcon;
